import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'
import { Answer } from '../models/Answer'
import { FormItem } from '../models/Form'
import { useFormEditor } from './FormContext'

type AnswerContextProps = {
  item: FormItem | undefined
  answer: Answer | undefined
}

const initAnswerContextPropsState: AnswerContextProps = {
  item: undefined,
  answer: undefined,
}

const AnswerContext = createContext<AnswerContextProps>(
  initAnswerContextPropsState
)

const useAnswer = () => useContext(AnswerContext)

interface AnswerContextProviderProps {
  item: FormItem
}

const AnswerContextProvider = ({
  item,
  children,
}: PropsWithChildren<AnswerContextProviderProps>) => {
  const { campaignEmployee } = useFormEditor()
  const [answer, setAnswer] = useState<Answer | undefined>(undefined)

  useEffect(() => {
    setAnswer(
      campaignEmployee?.answers.find((answer) => answer.formItemId === item.id)
    )
  }, [])

  return (
    <AnswerContext.Provider
      value={{
        item,
        answer,
      }}
    >
      {children}
    </AnswerContext.Provider>
  )
}

type AnswerContextProviderType = typeof AnswerContextProvider

export {
  AnswerContextProvider,
  useAnswer,
  type AnswerContextProviderType,
  type AnswerContextProviderProps,
}
